import Debug from 'debug';
import Cig from '../util/Cig';
import buildCigObjectsUrl from "../util/cig-objects-url";

/**
 * Fired on the <pub-slug>?/change-password page
 */
export default {
	async init() {
		try {
			Debug(`cig:info:sage:route:changePassword`)(`init start`);

			// Get CIG Objects blob
			const url = await buildCigObjectsUrl('person', 'change-password.json');

			Cig.loadExternalScript(url, '#inline-change-password', () => console.log('CIG Objects Loaded'));

		} catch (err) {
			Debug(`cig:error:sage:route:changePassword`)(`Change Password Route init Error: %s %o`, err.message, err);
			throw new Error(err);
		}
	},

	// Fires after init
	finalize() {
		try {
			Debug(`cig:info:sage:route:changePassword`)(`finalize start`);

		} catch (err) {
			Debug(`cig:error:sage:route:changePassword`)(`Change Password Route finalize Error: %s %o`, err.message, err);
			throw new Error(err);
		}
	},
};
